<template>
  <div class="mainChild page-content" id="mainChild">
    <div>
      <el-breadcrumb separator="/" class="breadcrumb">
        <el-breadcrumb-item>品牌管理</el-breadcrumb-item>
        <el-breadcrumb-item>资质查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <section style="padding: 20px;margin-bottom: 10px;background-color: white;">
      <div class="title f16" style="font-size: 20px;font-weight: 600;margin: 16px 0 16px 0;">
        <span v-for="(item, i) in newPlateList" :key="i" :class="activeKey == item.dictCode ? 'active' : ''"
          @click="navChange(item)">{{ item.dictName }}</span>
      </div>
      <section class="seaerch-wrapper" style="padding: 0px;margin: 0px;">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="公司名称" :label-width="formLabelWidth">
            <el-input :clearable="true" placeholder="请输入公司名称" v-model="list.keyword" size="small"
              @keyup.enter.native="getList(1)"></el-input>
          </el-form-item>
          <el-form-item label="店铺名称" :label-width="formLabelWidth">
            <el-input :clearable="true" placeholder="请输入店铺名称" v-model="list.shopname" size="small"
              @keyup.enter.native="getList(1)"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="getList(1)">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
    </section>
    <section class="content-warpper">
      <div class="headerBrand">
        <div class="searchContainer">
          <div class="downBtn">
            <el-button @click="downTable" type="primary" size="small" :loading="downTableTrue">下载数据</el-button>
          </div>
        </div>
      </div>
      <div class="downContainer">
        <!--表格-->
        <el-table ref="multipleTable" :data="tableList" tooltip-effect="dark" style="width: 100%"
          v-loading="dataLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
          <el-table-column label="序号" align="left" type="index" width="65" fixed="left">
            <template slot-scope="scope">
              {{ indexMethod(scope.$index) }}
            </template>
          </el-table-column>
          <el-table-column label="公司名称" width="220" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.companyName || '--' }}
            </template>
          </el-table-column>
          <el-table-column label="店铺名称" width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.shopname || '--' }}
            </template>
          </el-table-column>
          <el-table-column label="营业执照注册号" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.regNo || '--' }}
            </template>
          </el-table-column>
          <el-table-column label="注册地址" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.address || '--' }}
            </template>
          </el-table-column>
          <el-table-column label="法定代表人" width="130">
            <template slot-scope="scope">
              {{ scope.row.legalPerson || '--' }}
            </template>
          </el-table-column>
          <el-table-column label="联系方式" width="170">
            <template slot-scope="scope">
              <!-- 无联系方式 -->
              <span v-if="getPhones(scope.row).length === 0">--</span>
              <!-- ≤5个直接展示 -->
              <div v-else-if="getPhones(scope.row).length <= 5">
                <div v-for="(p, i) in getPhones(scope.row)" :key="i" style="line-height: 1.6;">{{ p }}</div>
              </div>
              <!-- >5个：展示前2个 + 查看按钮 -->
              <div v-else>
                <div style="line-height: 1.6;">{{ getPhones(scope.row).slice(0, 2).join('、') }} 等{{ getPhones(scope.row).length }}个</div>
                <el-button type="text" size="small" @click="showPhones(scope.row)">查看</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="平台" width="110">
            <template slot-scope="scope">
              {{ platformName(scope.row.platform) }}
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="170">
            <template slot-scope="scope">
              {{ formatTime(scope.row.createdAt) }}
            </template>
          </el-table-column>
          <el-table-column label="更新时间" width="170">
            <template slot-scope="scope">
              {{ formatTime(scope.row.updatedAt) }}
            </template>
          </el-table-column>
          <el-table-column label="举证图片" min-width="200">
            <template slot-scope="scope">
              <div v-if="getImages(scope.row).length > 0" style="display: flex;flex-wrap: wrap;gap: 4px;">
                <el-image v-for="(img, idx) in getImages(scope.row)" :key="idx" :src="img" fit="cover"
                  style="width: 48px;height: 48px;border-radius: 2px;cursor: pointer;"
                  :preview-src-list="getImages(scope.row)" :initial-index="idx"></el-image>
              </div>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="90" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <pagination v-if="tableList && tableList.length > 0" :currentPage="paginae.currentPage"
          :pageSizes="paginae.pageSizes" :total="paginae.total" @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"></pagination>
      </div>
    </section>

    <!-- 编辑弹窗 -->
    <el-dialog title="编辑资质" :visible.sync="editVisible" width="600px" :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-width="130px">
        <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="editForm.companyName" disabled></el-input>
        </el-form-item>
        <el-form-item label="营业执照注册号" prop="regNo">
          <el-input v-model="editForm.regNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="注册地址" prop="address">
          <el-input v-model="editForm.address" disabled></el-input>
        </el-form-item>
        <el-form-item label="法定代表人" prop="legalPerson">
          <el-input v-model="editForm.legalPerson" disabled></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="phones">
          <el-input v-model="editForm.phones" placeholder="请输入联系方式"></el-input>
        </el-form-item>
        <el-form-item label="平台">
          <span>{{ platformName(editForm.platform) }}</span>
        </el-form-item>
        <el-form-item label="举证图片">
          <div v-if="getImages(editForm).length > 0" style="display: flex;flex-wrap: wrap;gap: 8px;">
            <el-image v-for="(img, idx) in getImages(editForm)" :key="idx" :src="img" fit="cover"
              style="width: 60px;height: 60px;border-radius: 4px;cursor: pointer;"
              :preview-src-list="getImages(editForm)" :initial-index="idx"></el-image>
          </div>
          <span v-else style="color: #909399;font-size: 0.85rem;">暂无举证图片</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editVisible = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" :loading="editLoading" @click="submitEdit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 联系方式查看弹窗 -->
    <el-dialog title="联系方式" :visible.sync="phoneVisible" width="420px">
      <div v-if="phoneList.length">
        <div v-for="(p, i) in phoneList" :key="i"
          style="padding: 8px 0;border-bottom: 1px dashed #ebeef5;font-size: 0.9rem;">
          <span style="color: #909399;margin-right: 8px;">{{ i + 1 }}.</span>{{ p }}
        </div>
      </div>
      <div v-else style="color: #909399;text-align: center;">暂无联系方式</div>
    </el-dialog>
  </div>
</template>

<script>
import pagination from "../../../components/dataTable/pagination";

export default {
  name: "QualificationStatistics",
  components: {
    pagination
  },
  data: function () {
    return {
      activeKey: "TB", // 当前选中平台
      newPlateList: [
        { dictCode: "TB", dictName: "淘宝" },
        { dictCode: "JD", dictName: "京东" }
      ],
      formLabelWidth: "100px",
      dataLoading: false,
      downTableTrue: false,
      tableList: [],
      list: {
        pageNo: 1,
        pageSize: 10,
        platform: "TB",
        keyword: "", // 公司名称搜索
        shopname: "" // 店铺名称搜索
      },
      paginae: {
        currentPage: 1,
        pageSizes: [10, 20, 50, 100],
        total: 0
      },
      // 编辑弹窗
      editVisible: false,
      editLoading: false,
      editForm: {
        uid: null,
        companyName: "",
        regNo: "",
        address: "",
        legalPerson: "",
        phones: "",
        platform: "",
        photoUrls: ""
      },
      editFormRules: {
        phones: [{ required: true, message: "请输入联系方式", trigger: "blur" }]
      },
      // 联系方式查看弹窗
      phoneVisible: false,
      phoneList: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 平台切换
    navChange(item) {
      this.activeKey = item.dictCode;
      this.list.platform = item.dictCode;
      this.getList(1);
    },
    // 平台中文名
    platformName(code) {
      const map = { TB: "淘宝", JD: "京东" };
      return map[code] || code || "--";
    },
    // 全局序号
    indexMethod(index) {
      return (this.list.pageNo - 1) * this.list.pageSize + index + 1;
    },
    // 时间格式化（兼容毫秒时间戳 / 日期字符串，空值显示 --）
    formatTime(v) {
      if (v === null || v === undefined || v === "") return "--";
      const num = Number(v);
      if (!isNaN(num)) return this.$options.filters.fullTime(num);
      return this.$options.filters.fullTime(v);
    },
    // 举证图片解析（photoUrls：空串 或 多个 URL 用逗号/分号分隔）
    getImages(row) {
      const v = (row.photoUrls || "").trim();
      if (!v) return [];
      return v.split(/[,;，；]/).filter(Boolean);
    },
    // 查询列表
    getList(e) {
      if (e == 1) {
        this.paginae.currentPage = 1;
        this.list.pageNo = 1;
      }
      this.dataLoading = true;
      let datas = {
        pageNo: this.list.pageNo,
        pageSize: this.list.pageSize,
        platform: this.list.platform
      };
      // 公司名称搜索（空值不传）
      if (this.list.keyword) {
        datas.keyword = this.list.keyword;
      }
      // 店铺名称搜索（空值不传）
      if (this.list.shopname) {
        datas.shopname = this.list.shopname;
      }
      fetch({
        url: "hcm/hcmStoreQualification/list",
        method: "get",
        params: datas,
        noFormat: true,
        responseType: "text"
      })
        .then(result => {
          let res = JSON.parse(result);
          if (res.status == "10000") {
            let data = res.data || {};
            this.tableList = data.list || [];
            this.paginae.total = data.total || 0;
          } else {
            this.$message({
              message: res.message || "查询失败",
              type: "error"
            });
          }
          this.dataLoading = false;
        })
        .catch(() => {
          this.dataLoading = false;
          this.$message.error("请求出错！");
        });
    },
    // 每页条数变化
    handleSizeChange(val) {
      this.list.pageSize = val;
      this.getList();
    },
    // 当前页变化
    handleCurrentChange(val) {
      this.list.pageNo = val;
      this.getList();
    },
    // 下载/导出（按当前查询条件导出）
    downTable() {
      this.downTableTrue = true;
      let datas = {
        pageNo: this.list.pageNo,
        pageSize: this.list.pageSize,
        platform: this.list.platform
      };
      // 公司名称搜索（空值不传）
      // 公司名称搜索（空值不传）
      if (this.list.keyword) {
        datas.keyword = this.list.keyword;
      }
      // 店铺名称搜索（空值不传）
      if (this.list.shopname) {
        datas.shopname = this.list.shopname;
      }
      fetch({
        url: "hcm/hcmStoreQualification/download",
        method: "get",
        params: datas,
        noFormat: true,
        responseType: "blob",
        timeout: 60 * 1000 * 30
      })
        .then(res => {
          let urlLink = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = urlLink;
          link.setAttribute("download", `资质数据_${this.platformName(this.list.platform)}.xlsx`);
          document.body.appendChild(link);
          link.click();
          this.downTableTrue = false;
        })
        .catch(() => {
          this.downTableTrue = false;
          this.$message.error("下载失败！");
        });
    },
    // 联系方式解析（支持逗号/分号/顿号/空格分隔）
    getPhones(row) {
      const v = (row.phones || "").trim();
      if (!v) return [];
      return v.split(/[,;，；、\s]+/).filter(Boolean);
    },
    // 查看全部联系方式
    showPhones(row) {
      this.phoneList = this.getPhones(row);
      this.phoneVisible = true;
    },
    // 打开编辑弹窗（回显当前行）
    openEdit(row) {
      this.editForm = {
        uid: row.uid,
        companyName: row.companyName || "",
        regNo: row.regNo || "",
        address: row.address || "",
        legalPerson: row.legalPerson || "",
        phones: row.phones || "",
        platform: row.platform || "",
        photoUrls: row.photoUrls || ""
      };
      this.editVisible = true;
      // 清除上一次校验状态
      this.$nextTick(() => {
        if (this.$refs.editForm) this.$refs.editForm.clearValidate();
      });
    },
    // 提交编辑（仅更新联系方式）
    submitEdit() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return;
        this.editLoading = true;
        let datas = {
          uid: this.editForm.uid,
          phones: this.editForm.phones
        };
        fetch({
          url: "hcm/hcmStoreQualification/updatePhonesById",
          method: "post",
          data: datas,
          noFormat: true,
          responseType: "text"
        })
          .then(result => {
            let res = JSON.parse(result);
            if (res.status == "10000") {
              this.$message({ type: "success", message: "保存成功" });
              this.editVisible = false;
              this.getList();
            } else {
              this.$message({ type: "error", message: res.message || "保存失败" });
            }
            this.editLoading = false;
          })
          .catch(() => {
            this.editLoading = false;
            this.$message.error("请求出错！");
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  text-align: center;

  span {
    padding-left: 33px;
    cursor: pointer;
  }

  span:hover,
  .active {
    color: #108cee;
  }
}
</style>
